<template>
  <div class="column product-tile-wrapper is-6-tablet is-6-desktop is-6-widescreen is-half-fullhd">
  
    <div class="product-tile product-tile-v2 product-black-block showall pa-15">
      <div class="store-item-header relative">
        <span class="st-item-brand has-text-weight-semibold is-size-7 is-uppercase">{{ item.brand ? item.brand.name : '-N/A-' }}</span>
        <span v-if="itemOnSale" class="st-item-sale has-text-weight-semibold">{{ itemOnSalePercentage }}</span>
      </div>
      <div class="store-item-thumbnail-wrap">
        <div @click.prevent="visitDetailPage()" class="store-item-thumbnail">
          <img v-if="item.image" :src="item.image+'?d=200x200'" :alt="item.name" />
          <img v-else src="@/assets/img/leaf.png" :alt="item.name" />
        </div>
      </div>

      <div :class="'store-item-plant-type is-inline-block ' + (item.product_family != 'cannabis' ? 'set-invisible' : '') ">
        <div :class="'plant-type-capsule relative is-capitalized is-size-7 ' + ( item.cannabis_attributes && item.cannabis_attributes.plant_type ? item.cannabis_attributes.plant_type : 'na')">
          <span>{{ item.cannabis_attributes && item.cannabis_attributes.plant_type ? item.cannabis_attributes.plant_type : '--N/A-'}}</span>
        </div>
      </div>
      <div :class="'store-item-thc-cbd-wrap columns is-mobile mb-0 ' + (item.product_family != 'cannabis' ? 'set-invisible' : '')">
        <div class="st-item-thc column is-half-mobile">
          <p class="is-size-7 has-text-weight-semibold"><span>THC</span><br/>
            <span
              v-if="thc"
            >{{ thc }}</span>
            <span v-else>-N/A-</span>
          </p>
        </div>
        <div class="st-item-cbd column is-half-mobile">
          <p class="is-size-7 has-text-weight-semibold"><span>CBD</span><br/>
            <span
              v-if="cbd"
            >{{ cbd }}</span>
            <span v-else>-N/A-</span>
          </p>
        </div>
      </div>
      
      <div class="store-item-product-title cursor-pointer" @click.prevent="visitDetailPage()">
         <h3 class="is-size-5 has-text-weight-bold">{{ item.name }}</h3>
      </div>

      <div class="store-item-price-action columns is-mobile m-0">
        <div class="st-item-price-detail column">
          <p class="is-size-7"><span class="has-text-weight-normal is-size-5">
            ${{ itemPrice }}</span>
            {{ itemPricePerWeight  }}
          </p>
        </div>
        <div class="st-item-action-detail has-text-right column">
          <button @click.prevent="visitDetailPage()" class="button add-to-cart is-size-6 has-text-weight-semibold is-fixed-add-to-cart">ADD TO STASH</button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Env from "@/env";
import {  mapActions } from "vuex";
import Helpers from "@/Components/Helpers/Helpers";
export default {
  data() {
    return {
      itemOnSale: false,
      itemOnSalePercentage: false,
    };
  },
  props: {
    item: Object,
    selectedstore: Object,
    callback: Function,
  },
  computed: {
    itemPrice() {
      if(this.item.variants[0] && this.item.variants[0].price){
        if(this.item.variants[0].sale_price && this.item.variants[0].sale_price < this.item.variants[0].price){
          this.itemOnSale = true;
          this.itemOnSalePercentage = (((this.item.variants[0].price-this.item.variants[0].sale_price) / this.item.variants[0].price)*100).toFixed(2) + '% OFF';
          return (this.item.variants[0].sale_price).toFixed(2);
        }
        this.itemOnSale = false;
        return (this.item.variants[0].price).toFixed(2);
      } 
      this.itemOnSale = false;
      return 0;
    },
    itemPricePerWeight() {
      return Helpers.getProductFirstVariantPricePerWeight(this.item);
    },

    thc() {
      return Helpers.getTHCValue(this.item);
    },

    cbd() {
      return Helpers.getCBDValue(this.item);
    },

  },
  methods: {
    visitDetailPage() {
      this.callback(this.item);
    },
    ucfirst(value) {
      return _.startCase(_.toLower(value));
    },
    // hasSaleTag(variants) {
    //   return Helpers.hasSaleTag(variants);
    // },
    /**
     * Add to cart
     */
    addToCart(data) {
      bus.$emit('location-landing-addto-cart', {
        modal: true,
        product: { id: this.item.id },
      });
    },
  }
};
</script>